import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    address,
    countryName,
    airlinesName,
    quarter,
    year,
    firstTime,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    agencyId,
    agencyName,
    taxAgentContract,
    taxAgentContractDate,
    certificate,
    fullName,
    signer,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [address.name]: Yup.string().required(address.errorMsg),
  [countryName.name]: Yup.string().required(countryName.errorMsg),
  [airlinesName.name]: Yup.string().required(airlinesName.errorMsg),
  [quarter.name]: Yup.number().required(quarter.errorMsg),
  [year.name]: Yup.number().required(year.errorMsg),
  [taxAgentContractDate.name]: Yup.number().required(taxAgentContractDate.errorMsg),
  [taxAgentContract.name]: Yup.string().required(taxAgentContract.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [supplementaryForThe.name]: Yup.string()
  .matches(/^\d+$/, supplementaryForThe.invalidMsg)
  .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
  .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
  .required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [agencyName.name]: Yup.string().required(agencyName.errorMsg),
  [agencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, agencyId.invalidMsg)
    .required(agencyId.errorMsg),

  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
});

export default validation;
